export const OPEN = 0;
export const EXPIRING = 1;
export const CLOSED = 2;
export const FIXED = 3;

export const ALLOTMENT = true;
export const FREESALE = false;

export const MAX_ROOM_ALLOCATION = 100;
export const OPEN_ALLOCATION_FREESALE_MIN = 0;
export const OPEN_ALLOCATION_FREESALE_MAX = 50;
export const CLOSED_FREESALE_MAX = 999;
export const CLOSED_ALLOCATION_FREESALE = -999;
export const OPEN_INFINITY = 99999;
export const OPEN_INFINITY_CHECK = 90000;

export const DEFAULT_ROOM_ALLOCATION = 10;
export const DEFAULT_ROOM_FREESALE_OPEN = 50;